import styled from "styled-components";
import {Row, Input, Button, Typography} from "antd";
import {InfoWindow} from "@react-google-maps/api";
const {Text} = Typography;

export const InfoRow = styled(Row)`
    display: flex;
    width: 300px;
    justify-content: center;
    align-items: center;
`;

export const InfoInput = styled(Input)`
    margin-top: 5px;
`;

export const InfoWindowStyled = styled(InfoWindow)`
    z-index: 999;
`;

export const InfoTypography = styled(Typography)`
    margin-top: 10px;
    font-weight: bold;
    font-size: 16px;
`;

export const InfoButton = styled(Button)`
    margin: 20px;
    height: 40px;
    width: 100px;
    font-weight: bold;
`;

export const RightBottomContainer = styled.div`
    position: absolute;
    background: #ffffffe3;
    z-index: 3;
    bottom: 0px;
    right: 0px;
    padding: 15px;
    border-radius: 4px;
`;
export const GroupColor = styled.div`
    background-color: ${props => props.color};
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin: auto 5px auto 0px;
`;
